import React, { useState, useEffect } from 'react';
import Layout from './components/Layout';
import MarkdownRenderer from './components/MarkdownRenderer';
import TableOfContents from './components/TableOfContents';
import { overviewContent } from './content/overview';
import { quickstartContent } from './content/gettingStarted/quickstart';
import { provisioningContent } from './content/gettingStarted/provisioning';
import { accessOverviewContent } from './content/access-paywall/overview';
import { reactQuickstartContent } from './content/access-paywall/reactQuickstart';
import { conceptsContent } from './content/access-paywall/concepts';
import { flowsContent } from './content/access-paywall/flows';
import { configurationContent } from './content/access-paywall/configuration';
import { eventsCallbacksContent } from './content/access-paywall/eventsCallbacks';
import { troubleshootingContent } from './content/access-paywall/troubleshooting';
import { securityContent } from './content/access-paywall/security';
import { testingLocallyContent } from './content/access-paywall/testingLocally';
import { copyPasteTemplatesContent } from './content/access-paywall/copyPasteTemplates';
import { tinyAnalyticsContent } from './content/tinyAnalytics';
import { 
  defaultEventsContent, 
  dashboardsExportContent,
  adminBasicsContent,
  testModeContent,
  supabaseIntegrationContent,
  multiTenantSetupContent,
  migratingContent,
  restApiContent,
  sdkReferenceContent,
  eventSchemasContent,
  faqContent
} from './content/stubs';
import './App.css';

function App() {
  const [currentPage, setCurrentPage] = useState<string>('overview');
  const [markdownContent, setMarkdownContent] = useState<string>('');

  useEffect(() => {
    // Set content based on current page
    switch (currentPage) {
      case 'overview':
        setMarkdownContent(overviewContent);
        break;
      case 'quickstart':
        setMarkdownContent(quickstartContent);
        break;
      case 'provisioning':
        setMarkdownContent(provisioningContent);
        break;
      case 'access-overview':
        setMarkdownContent(accessOverviewContent);
        break;
      case 'react-quickstart':
        setMarkdownContent(reactQuickstartContent);
        break;
      case 'concepts':
        setMarkdownContent(conceptsContent);
        break;
      case 'flows':
        setMarkdownContent(flowsContent);
        break;
      case 'configuration':
        setMarkdownContent(configurationContent);
        break;
      case 'events-callbacks':
        setMarkdownContent(eventsCallbacksContent);
        break;
      case 'troubleshooting':
        setMarkdownContent(troubleshootingContent);
        break;
      case 'security':
        setMarkdownContent(securityContent);
        break;
      case 'testing-locally':
        setMarkdownContent(testingLocallyContent);
        break;
      case 'copy-paste-templates':
        setMarkdownContent(copyPasteTemplatesContent);
        break;
      case 'analytics-quickstart':
        setMarkdownContent(tinyAnalyticsContent);
        break;
      case 'default-events':
        setMarkdownContent(defaultEventsContent);
        break;
      case 'dashboards-export':
        setMarkdownContent(dashboardsExportContent);
        break;
      case 'admin-basics':
        setMarkdownContent(adminBasicsContent);
        break;
      case 'test-mode':
        setMarkdownContent(testModeContent);
        break;
      case 'supabase-integration':
        setMarkdownContent(supabaseIntegrationContent);
        break;
      case 'multi-tenant-setup':
        setMarkdownContent(multiTenantSetupContent);
        break;
      case 'migrating':
        setMarkdownContent(migratingContent);
        break;
      case 'rest-api':
        setMarkdownContent(restApiContent);
        break;
      case 'sdk-reference':
        setMarkdownContent(sdkReferenceContent);
        break;
      case 'event-schemas':
        setMarkdownContent(eventSchemasContent);
        break;
      case 'faq':
        setMarkdownContent(faqContent);
        break;
      default:
        setMarkdownContent(overviewContent);
    }
  }, [currentPage]);

  const handlePageChange = (page: string) => {
    setCurrentPage(page);
  };

  return (
    <Layout 
      currentPage={currentPage}
      onPageChange={handlePageChange}
      tableOfContents={
        markdownContent ? <TableOfContents content={markdownContent} /> : null
      }
    >
      <MarkdownRenderer content={markdownContent} />
    </Layout>
  );
}

export default App; 